import React, { useEffect } from "react";
import { StatusResponse } from "../../lib-api";
import ApplicationContainer from "../applicationContainer";
import ApplicationContent from "../applicationContent";
import TopStripIndicator from "./topStripIndicator";
import { trackEcommerce } from "../../util/gtm";
import { StringUtil } from "../../util/stringUtil";

interface Props {
  data: StatusResponse;
}


const ApplicationAccepted: React.FunctionComponent<Props> = props => {
    useEffect(() => {
        //document.onreadystatechange = () => {
        //    if (document.readyState === 'complete') {
        //        trackEcommerce(
        //            props.data.referenceID,
        //            props.data.loanAmount,
        //            props.data.durationMonths
        //        )
        //    }
        //};
      
    }, []);

  return (
    <ApplicationContainer>
      <TopStripIndicator />
      {props.data.status == "ACCEPTED" &&
        (props.data.subStatus == "WAITING_DELIVERY" ||
          props.data.subStatus == "WAITING_PAYMENT") && (
          <ApplicationContent className="d-flex align-items-center flex-column">
            <div className="check-cirle-container mb-2">
              <img src="/images/tick.svg" />
            </div>
                  <h2 className="text-primary">Tillykke med dit nye lån på {StringUtil.numberWithCommas(props.data.loanAmount)} kr.</h2>
            <div className="py-5 text-center">
              <h3>Din ansøgning er accepteret og underskrevet</h3>
              <p>
               Har du ansøgt i tidsrummet 8:00-19:00 vil du modtage pengene på din Nemkonto inden for 10 minutter.
              </p>
                      <br/>
              <p>
                          Vi vil sætte stor pris på hvis du kan bruge 2 minutter på at skrive en anmeldelse af Lendmore.dk på <a href="https://www.trustpilot.com/review/lendmore.dk" target="_blank">Trustpilot</a>
              </p>
                     
                   
                  </div>
                  <div className="TrustPilot">
                      <a href="https://www.trustpilot.com/review/lendmore.dk">
                          <img className="img-responsive" src="https://cdn.freelogovectors.net/wp-content/uploads/2018/08/trustpilot_logo.png" />
                      </a>
                  </div>
          </ApplicationContent>
        )}
      {props.data &&
        props.data.status == "ACCEPTED" &&
        props.data.subStatus == "PAID_OUT" && (
          <ApplicationContent className="d-flex align-items-center flex-column">
            <div className="check-cirle-container mb-2">
              <img src="/images/tick.svg" />
            </div>
                  <h2 className="text-primary">Tillykke med dit nye lån på {StringUtil.numberWithCommas(props.data.loanAmount)} kr.</h2>
            <div className="py-5 text-center">
              <h3>Din ansøgning er nu accepteret og underskrevet</h3>
              <p>
               Har du ansøgt i tidsrummet 8:00-19:00 vil du modtage pengene på din Nemkonto inden for 10 minutter.
              </p>
              <p>
                Vi vil sætte stor pris på hvis du kan bruge 2 minutter på at skrive en anmeldelse på Trustpilot
              </p>
                      <a href="https://www.trustpilot.com/search?query=lendmore">
                          <img src="https://cdn.freelogovectors.net/wp-content/uploads/2018/08/trustpilot_logo.png" />
                      </a>
                     
            </div>
              </ApplicationContent>

        )}
    </ApplicationContainer>
  );
};

export default ApplicationAccepted;
